import React, { Component } from "react";
import moment from "moment";
import { Row, Col } from "react-flexbox-grid";
import {
  Timeline as TimelineWrapper,
  TimelineEvent
} from "react-event-timeline";
import Icon from "material-ui-next/Icon";
import Paper from "material-ui-next/Paper";
import {
  TextField,
  CardValue,
  StyledButton,
  Loadable,
  Errorable,
  ViewSaleButton,
  CurrencyValue
} from "components/support";
import { colors } from "assets";

import { SaleStatus } from "core/enum";

import styles from "./styles";

const formattedMoney = value => {
  return <CurrencyValue value={value * 100} type="money" />; //TODO
};

class Timeline extends Component {
  getContent() {
    return this.props.content;
  }

  getTotalPages = pagination => {
    const pageCount = Math.ceil(
      Math.max(pagination.total, 1) / Math.max(pagination.perPage, 1)
    );
    return pagination.perPage === 0 ? 0 : pageCount;
  };

  getGrossProfit = sale => {
    return sale.cart_items
      .map(v => v.sellable.cost_value || 0)
      .reduce((acc, costValue) => acc + costValue, 0);
  };

  render() {
    const { className } = this.props;

    return (
      <Loadable loading={this.props.loading}>
        <Paper elevation={1} className={className}>
          <Row>
            <Col xs={12}>
              {this.getContent().length === 0 && (
                <Errorable error={true} errorMessage="Nenhum dado encontrado">
                  <div style={{ height: "250px" }}></div>
                </Errorable>
              )}
              {this.getContent().length > 0 && (
                <TimelineWrapper>
                  {this.getContent().map(sale => (
                    <TimelineEvent
                      className="timeline__content"
                      key={sale.uuid}
                      title={`${
                        (sale.company || {}).name
                      } - ${(sale.pos_operator && sale.pos_operator.name) ||
                        "Vendedor não identificado"}`}
                      createdAt={moment(sale.activated_at).fromNow()}
                      icon={
                        <Icon
                          style={{
                            color: "green",
                            marginLeft: "-3px",
                            marginTop: "-4px"
                          }}
                        >
                          attach_money
                        </Icon>
                      }
                    >
                      <Row middle="xs">
                        <Col xs={6} sm={3}>
                          <CardValue small>
                            {sale.salesman && sale.salesman.name} vendeu{" "}
                            {formattedMoney(sale.total_value)}{" "}
                          </CardValue>
                        </Col>
                        <Col xs={6} sm={3}>
                          {SaleStatus[sale.status] === SaleStatus.cancelled && (
                            <CardValue small>
                              <span className="sale-canceled">CANCELADA</span>
                            </CardValue>
                          )}
                          {SaleStatus[sale.status] === SaleStatus.error && (
                            <CardValue small>
                              Erro na Venda
                              {sale.document.type_name && sale.document.number && (
                                <span>
                                  ({sale.document.type_name} n.:{" "}
                                  {sale.document.number})
                                </span>
                              )}
                            </CardValue>
                          )}
                          {SaleStatus[sale.status] === SaleStatus.active && (
                            <ViewSaleButton sale={sale} />
                          )}
                        </Col>
                        <Col xs={6} sm={3}>
                          {sale.can_cancel && (
                            <StyledButton
                              flat
                              accent
                              style={{
                                color: colors.accent.normal,
                                fontSize: "12px"
                              }}
                              label="Cancelar Venda"
                              onClick={() => this.props.onDelete(sale)}
                            />
                          )}
                        </Col>
                      </Row>
                    </TimelineEvent>
                  ))}
                </TimelineWrapper>
              )}
            </Col>
          </Row>
          {this.getContent().length > 0 && (
            <Row center="xs" between="xs" middle="xs">
              <Col xs={4}>
                <div style={{ paddingBottom: 8 }}>
                  <StyledButton
                    flat
                    label="Anterior"
                    onClick={() =>
                      this.props.handlePageChange(
                        this.props.pagination.currentPage - 1
                      )
                    }
                    disabled={this.props.pagination.currentPage === 1}
                  />
                </div>
              </Col>
              <Col xs={4}>
                <div>
                  <span>Página</span>
                  <div
                    style={{
                      display: "inline-block",
                      width: "70px",
                      paddingBottom: 8,
                      padding: "0 4px"
                    }}
                  >
                    <TextField
                      fullWidth
                      value={this.props.pagination.currentPage}
                      readOnly
                      noMargin
                    />
                  </div>
                  <span>de {this.getTotalPages(this.props.pagination)}</span>
                </div>
              </Col>
              <Col xs={4}>
                <div style={{ paddingBottom: 8 }}>
                  <StyledButton
                    flat
                    label="Próximo"
                    onClick={() =>
                      this.props.handlePageChange(
                        this.props.pagination.currentPage + 1
                      )
                    }
                    disabled={
                      this.props.pagination.currentPage ===
                      this.getTotalPages(this.props.pagination)
                    }
                  />
                </div>
              </Col>
            </Row>
          )}
        </Paper>
      </Loadable>
    );
  }
}

export default styles(Timeline);



// WEBPACK FOOTER //
// ./src/components/app/history/sales/timeline/index.js